import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PermissionGuard } from 'src/guards/permission/permissionguard.guard';
import { AuthenticationGuard } from 'src/guards/auth/auth.guard';
import { PreloadAllModules } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'home',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { slug: 'home' },
  },
  {
    path: 'clarity',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./clarity/clarity.module').then(m => m.ClarityModule),
    data: { slug: 'clarity' },
  },
  {
    path: 'summary',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./summary/summary.module').then(m => m.SummaryModule),
    data: { slug: 'summary' },
  },
  {
    path: 'overview',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./overview/overview.module').then(m => m.OverviewModule),
    data: { slug: 'overview' },
  },
  {
    path: 'charts',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./chart/chart.module').then(m => m.ChartModule),
    data: { slug: 'charts' },
  },
  {
    path: 'report',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./report/report.module').then(m => m.ReportModule ),
    data: { slug: 'report' },
  },
  {
    path: 'report-download',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./report-download/report-download.module').then(m => m.ReportDownloadModule),
    data: { slug: 'report-download' },
  },
  {
    path: 'data-download',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./data-download/data-download.module').then(m => m.DataDownloadModule),
    data: { slug: 'data-download' },
  },
  {
    path: 'maintenance',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule),
    data: { slug: 'maintenance' },
  },
  {
    path: 'settings',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    data: { slug: 'settings' },
  },
  {
    path: 'user-manual',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./usermanual/usermanual.module').then(m => m.UsermanualModule),
    data: { slug: 'user-manual' },
  },
  {
    path: 'transient-pressure',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./transientpressure/transientpressure.module').then(m => m.TransientpressureModule),
    data: { slug: 'transient-pressure' },
  },
  {
    path: 'activedata',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./active-data/active-data.module').then(m => m.ActiveDataModule),
    data: { slug: 'activedata' },
  },
  {
    path: 'installation',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./installation/installation.module').then(m => m.InstallationModule),
    data: { slug: 'installation' },
  },
  {
    path: 'predictive-analysis',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./predicitive-analysis/predicitive-analysis.module').then(m => m.PredicitiveAnalysisModule),
    data: { slug: 'predictive-analysis' },
  },
  {
    path: 'unauthorized',
    canActivate: [AuthenticationGuard],
    loadChildren: () => import('./unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
  },
  {
    path: 'depth-monitor',
    canActivate: [AuthenticationGuard, PermissionGuard],
    loadChildren: () => import('./depth-monitor/depth.module').then(m => m.DepthModule),
    data: { slug: 'depth-monitor' },
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: false,
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled' // optional
   })],
  exports: [RouterModule],
})

export class AppRoutingModule {}

